import gql from "graphql-tag";

export default gql`
    mutation($idProject: Int!){
        removeProject(idProject: $idProject)
  }
`;
